'use client';

import { useEffect, useState, type RefObject } from 'react';

export function useViewportAutoScale(
  containerRef: RefObject<HTMLDivElement | null>,
  deviceWidth: number,
) {
  const [autoScale, setAutoScale] = useState(1);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    function computeScale() {
      // Subtract horizontal padding (2 × 20px) from available width
      const availableWidth = container!.clientWidth - 40;
      setAutoScale(Math.min(1, availableWidth / deviceWidth));
    }

    computeScale();

    const ro = new ResizeObserver(computeScale);
    ro.observe(container);
    return () => ro.disconnect();
  }, [containerRef, deviceWidth]);

  return autoScale;
}
